import { queryOptions, useQuery, type UseQueryResult } from '@tanstack/react-query';

import { cantons } from '../data/cantons';
import type { Canton } from '../types';

const SIMULATED_LATENCY_MS = 100;

export async function fetchCantons(): Promise<Canton[]> {
    return new Promise((resolve) => {
        setTimeout(() => resolve(cantons), SIMULATED_LATENCY_MS);
    });
}

export const cantonsQueryOptions = queryOptions({
    queryKey: ['settings', 'cantons'] as const,
    queryFn: fetchCantons,
});

export function useCantons(): UseQueryResult<Canton[]> {
    return useQuery(cantonsQueryOptions);
}
